import React from "react";
import { colors } from "../../theme/color";
import PaypalHandler from "../PayPal";
import {
  CardDetailsInput,
  CardDetailsLabel,
  LabelSpan,
  PayBtn,
} from "./PaymentInfo.styled";
import { payWithAccountData } from "./data";
import { toast } from "react-toastify";

interface PayWithAccountProps {
  data?: any;
}
const PayWithAccount = (props: PayWithAccountProps) => {
  console.log(props);

  const [showBankAccount, toggleShowBankAccount] = React.useState(false);
  return (
    <>
      <br />
      <PayBtn
        onClick={() => toggleShowBankAccount(!showBankAccount)}
        backgroundColor={colors.BLACK}
        color={colors.Primary}
        $active
      >
        Pay with Bank Account
      </PayBtn>
      {showBankAccount && (
        <>
          {payWithAccountData.map((data) => (
            <CardDetailsLabel>
              <LabelSpan>
                {data.label}
                {data.labelIcon && <i>{data.labelIcon}</i>}
              </LabelSpan>
              <CardDetailsInput type={data.type} />
            </CardDetailsLabel>
          ))}

          <PayBtn
            onClick={() => {
              window.location.href = `${window.location.origin}/p/${props?.data?.paymentIntent?.reference}/status?method=paypal`;
            }}
            $active
          >
            Complete payment
          </PayBtn>
        </>
      )}
      <PaypalHandler
        reference={props.data?.paymentIntent?.reference}
        paypalClientId={props.data?.paypal?.paypalClientId}
        amount={props.data?.productPrice}
      />
      <PayBtn
        onClick={() => toast.success("Coming soon")}
        backgroundColor={colors.BLACK}
        color={colors.Primary}
        $active
        css={`
          display: flex;
          text-align: center;
          justify-content: center;
          cursor: not-allowed;
          align-items: center;
        `}
      >
        <img
          style={{ maxWidth: 48 }}
          src="https://logos-world.net/wp-content/uploads/2020/12/Cash-App-Symbol-500x281.png"
        />
        <span>Cash App Pay</span>
      </PayBtn>
    </>
  );
};

export default PayWithAccount;
